import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { amountFormat } from "../../../utils/WalletUtils";

const StoreDataOverview = (props) => {
  // These are all states use in this component
  const { sendToAgoraTransaction, hideConfirmDiv, transactionOverviewData, t } =
    props;

  const [senders, setSenders] = useState([]);
  const [receivers, setReceivers] = useState([]);
  const [txFee, setTxFee] = useState();
  const [freezingFee, setFreezingFee] = useState();
  const [payloadFee, setPayloadFee] = useState();
  const [payload, setPayload] = useState();

  useEffect(() => {
    if (transactionOverviewData) {
      setTxFee(transactionOverviewData.fee_tx);
      setFreezingFee(transactionOverviewData._fee_freezing);
      setSenders(transactionOverviewData.senders);
      setReceivers(transactionOverviewData.receivers);
      setPayloadFee(transactionOverviewData.fee_payload);
      setPayload(transactionOverviewData.payload.toString("base64"));
    }
  }, [transactionOverviewData]);

  // Method use to confirm transaction
  const confirmTransaction = () => {
    sendToAgoraTransaction();
  };

  return (
    // Store Data confirm screen
    <div className="Content">
      <div className="TableBg cardBg">
        <>
          <div className="ContHeader">
            <h1 className="OverviewTitle">{t("Transaction_Overview")}</h1>
          </div>
          <div className="ContHeader">
            <h3>{t("Senders_Detail")}</h3>
          </div>
          {/* Sender Detail section */}
          <div className="table-responsive trans-overview-page">
            <table className="table">
              <thead className="tableHead">
                <tr>
                  <th> {t("Address")}</th>
                  <th> {t("Amount")}</th>
                </tr>
              </thead>
              {senders && senders.length > 0 ? (
                <tbody className="SenderTable address-list">
                  {senders.map((info, index) => (
                    <tr key={index}>
                      <td>
                        <div className="purpleText tooltipfull">
                          {info.address.toString()}
                        </div>
                      </td>
                      <td>
                        {amountFormat(info.amount)}
                        {" BOA"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </table>
          </div>
          <div className="ContHeader">
            <h3>{t("Receivers_Detail")}</h3>
          </div>
          {/* Receivers Detail section */}
          <div className="table-responsive trans-overview-page">
            <table className="table">
              <thead className="tableHead">
                <tr>
                  <th> {t("Address")}</th>
                  <th> {t("Amount")}</th>
                </tr>
              </thead>
              {receivers && receivers.length > 0 ? (
                <tbody className="tablebody tbody1">
                  {receivers.map((info, index) => (
                    <tr key={index}>
                      <td>
                        <div className="purpleText tooltipfull">
                          {info.address.toString()}
                        </div>
                      </td>
                      <td>
                        {amountFormat(info.amount)}
                        {" BOA"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </table>
          </div>
          <div className="ContHeader">
            <h3>{t("Payload")}</h3>
          </div>
          <div className="data-value">
            <p>{payload}</p>
          </div>
          <div className="TransactionFee">
            <div>
              <h3 className="mb-0">{t("Transaction_Fee")}</h3>
              <p>
                {txFee && amountFormat(txFee)}
                {" BOA"}
              </p>
            </div>
            <div />
          </div>
          {payloadFee &&
            payloadFee.toString() !== "" &&
            payloadFee.toString() !== "0" && (
              <div className="TransactionFee">
                <div>
                  <h3 className="mb-0">{t("Payload_Fee")}</h3>
                  <p>
                    {payloadFee && amountFormat(payloadFee)}
                    {" BOA"}
                  </p>
                </div>
                <div />
              </div>
            )}
          {freezingFee &&
            freezingFee.toString() !== "" &&
            freezingFee.toString() !== "0" && (
              <div className="TransactionFee">
                <div>
                  <h3 className="mb-0">{t("Payload_Fee")}</h3>
                  <p>
                    {freezingFee && amountFormat(freezingFee)}
                    {" BOA"}
                  </p>
                </div>
                <div />
              </div>
            )}
          <div className="OverviewBtns">
            <button
              className="btn btn-default BackBtnSmall"
              onClick={hideConfirmDiv}
            >
              {t("Back")}
            </button>
            {/* Button to Store Data confirmation  */}
            <button
              onClick={confirmTransaction}
              className="btn btn-default ConfirmBtnSmall"
            >
              {t("Confirm")}
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default withTranslation()(StoreDataOverview);
